import React, { Component } from 'react';
import { ChevronRightIcon } from '../ui';
import Theme from '../theme';
import { translate } from 'react-i18next';
import WelcomeBackground from '../assets/images/welcome2-background.png';
import NutritionBackground from '../assets/images/nutrition-background1.png';
import TrackingBackground from '../assets/images/tracking-background1.png';
import WorkoutBackground from '../assets/images/workout-background1.png';
import GroupWorkoutBackground from '../assets/images/group-workout-background.png';
import Slider from 'react-slick';

class HomeCarouselWeb extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.slider.slickPlay();
    }

    next = () => {
        this.slider.slickNext();
    }
    previous = () => {
        this.slider.slickPrev();
    }

    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            dotsClass: 'slick-dots fitbeat-slider-dots',
            appendDots: dots => (
                <div>
                    <div onClick={this.previous} className='previous'>
                        <ChevronRightIcon color={Theme.WHITE} height={20} width={20} />
                    </div>
                    {dots}
                    <div onClick={this.next} className='next'>
                        <ChevronRightIcon color={Theme.WHITE} height={20} width={20} />
                    </div>
                </div >
            ),
        };
        const { t, firstSliderImageSource } = this.props;
        const firstImageSource = firstSliderImageSource ?? WorkoutBackground;

        return (
          <>
            <Slider ref={(c) => (this.slider = c)} {...settings}>
              <div className='content-container'>
                <div class='carousel-gradient-top' />
                <img src={firstImageSource} />
                <div class='carousel-gradient-bottom' />
                <div class='header-description'>
                  <p className='content-header-text'>
                    {t('gymSmartWith').toUpperCase()}
                  </p>
                  <p className='content-description-text'>
                    {t('fitnessRevolution')}
                  </p>
                </div>
              </div>
              <div className='content-container'>
                <div class='carousel-gradient-top' />
                <img src={WelcomeBackground} />
                <div class='carousel-gradient-bottom' />
                <div class='header-description'>
                  <p className='content-header-text'>{t('workoutHeader')}</p>
                  <p className='content-description-text'>{t('workoutText')}</p>
                </div>
              </div>
              <div className='content-container'>
                <div class='carousel-gradient-top' />
                <img src={NutritionBackground} />
                <div class='carousel-gradient-bottom' />
                <div class='header-description'>
                  <p className='content-header-text'>{t('nutritionHeader')}</p>
                  <p className='content-description-text'>
                    {t('nutritionText')}
                  </p>
                </div>
              </div>
              <div className='content-container'>
                <div class='carousel-gradient-top' />
                <img src={TrackingBackground} />
                <div class='carousel-gradient-bottom' />
                <div class='header-description'>
                  <p className='content-header-text'>{t('trackingHeader')}</p>
                  <p className='content-description-text'>
                    {t('trackingText')}
                  </p>
                </div>
              </div>
              <div className='content-container'>
                <div class='carousel-gradient-top' />
                <img src={GroupWorkoutBackground} />
                <div class='carousel-gradient-bottom' />
                <div class='header-description'>
                  <p className='content-header-text'>{t('groupHeader')}</p>
                  <p className='content-description-text'>{t('groupText')}</p>
                </div>
              </div>
            </Slider>
          </>
        );
    }
}

export default translate(['auth'], { wait: true })(HomeCarouselWeb)
